import React, { useState, useEffect } from 'react';
import { BsSun, BsMoon } from 'react-icons/bs';
import { AiOutlineMenu, AiOutlineClose } from 'react-icons/ai';
import { HiArrowRight } from 'react-icons/hi';
import { useTheme } from '../context/ThemeContext';

const navLinks = [
  { id: 'about', label: 'About' },
  { id: 'professional-journey', label: 'Journey' },
  { id: 'projects', label: 'Projects' },
  { id: 'life-and-interests', label: 'Life & Interests' },
  { id: 'contact', label: 'Contact' },
];

const Navbar = () => {
  const { isDark, toggleTheme } = useTheme();
  const [showNavbar, setShowNavbar] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY && currentScrollY > 80) {
        setShowNavbar(false);
      } else {
        setShowNavbar(true);
      }
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  const handleNavClick = () => setMobileOpen(false);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-transform duration-300
        dark:bg-[#0a0d23]/95 bg-white/95 backdrop-blur-md
        dark:border-b dark:border-slate-700/50 border-b border-slate-200/80
        shadow-sm ${showNavbar ? 'translate-y-0' : '-translate-y-full'}`}
    >
      <div className="max-w-screen-xl mx-auto px-6 py-4 flex items-center justify-between">

        {/* Brand */}
        <a
          href="#home"
          className="text-xl font-bold bg-gradient-to-r from-blue-500 to-purple-600 bg-clip-text text-transparent hover:opacity-80 transition-opacity"
        >
          Santiago Ornelas
        </a>

        {/* Desktop Nav Links */}
        <ul className="hidden md:flex items-center gap-1">
          {navLinks.map(link => (
            <li key={link.id}>
              <a
                href={`#${link.id}`}
                className="px-3 py-2 text-sm font-medium rounded-lg
                  dark:text-slate-300 text-slate-600
                  dark:hover:text-blue-400 hover:text-blue-500
                  dark:hover:bg-blue-500/10 hover:bg-blue-50
                  transition-all duration-200"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        {/* Right Side Actions */}
        <div className="flex items-center gap-2">
          {/* Dark/Light Toggle */}
          <button
            onClick={toggleTheme}
            aria-label="Toggle theme"
            className="p-2 rounded-lg dark:text-slate-400 text-slate-500
              dark:hover:bg-slate-700/50 hover:bg-slate-100
              transition-all duration-200"
          >
            {isDark
              ? <BsSun size={18} className="text-yellow-400" />
              : <BsMoon size={18} />
            }
          </button>

          {/* Book a Call — desktop */}
          <button
            type="button"
            className="hidden md:flex items-center gap-1.5 px-4 py-2 rounded-full
              bg-gradient-to-r from-blue-500 to-purple-600 text-white
              text-sm font-medium hover:shadow-lg hover:shadow-blue-500/25
              hover:scale-105 transition-all duration-200"
          >
            Book a Call <HiArrowRight size={14} />
          </button>

          {/* Mobile Hamburger */}
          <button
            onClick={() => setMobileOpen(prev => !prev)}
            className="md:hidden p-2 rounded-lg dark:text-slate-400 text-slate-500
              dark:hover:bg-slate-700/50 hover:bg-slate-100 transition-all duration-200"
            aria-label="Toggle menu"
          >
            {mobileOpen
              ? <AiOutlineClose size={20} />
              : <AiOutlineMenu size={20} />
            }
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden dark:border-t border-t dark:border-slate-700/50 border-slate-200/80
          dark:bg-[#0a0d23] bg-white px-6 py-4 flex flex-col gap-2">
          {navLinks.map(link => (
            <a
              key={link.id}
              href={`#${link.id}`}
              onClick={handleNavClick}
              className="px-3 py-2.5 text-sm font-medium rounded-lg
                dark:text-slate-300 text-slate-700
                dark:hover:text-blue-400 hover:text-blue-500
                dark:hover:bg-blue-500/10 hover:bg-blue-50
                transition-all duration-200"
            >
              {link.label}
            </a>
          ))}
          <button
            type="button"
            onClick={handleNavClick}
            className="mt-2 flex items-center justify-center gap-1.5 px-4 py-2.5 rounded-full
              bg-gradient-to-r from-blue-500 to-purple-600 text-white
              text-sm font-medium transition-all duration-200"
          >
            Book a Call <HiArrowRight size={14} />
          </button>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
